import React, { Suspense } from "react";
import { MsalProvider } from "@azure/msal-react";
import { Routes, Route } from "react-router";
import { CSpinner } from "@coreui/react";
import { GlobalStoreProvider } from "./context/GlobalStoreContext";
import "./assets/scss/style.scss";
import PropTypes from "prop-types";

const loading = (
  <div className="d-flex justify-content-center">
    <CSpinner />
  </div>
);

const Home = React.lazy(() => import("./home/home"));
const Login = React.lazy(() => import("./pages/login/Login"));
const Page404 = React.lazy(() => import("./pages/page404/Page404"));
const Page500 = React.lazy(() => import("./pages/page500/Page500"));

const App = ({ pca }) => {
  return (
    <MsalProvider instance={pca}>
      <GlobalStoreProvider>
        <Suspense fallback={loading}>
          <Routes>
            <Route exact path="/" name="Login" element={<Login />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route path="*" name="Home" element={<Home />} />
          </Routes>
        </Suspense>
      </GlobalStoreProvider>
    </MsalProvider>
  );
};

export default App;
App.propTypes = {
  pca: PropTypes.object.isRequired,
};
